import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiEpBillingBill {
}
ApiEpBillingBill.create = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/bill/`,
    method: "POST",
});
ApiEpBillingBill.delete = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/bill/${req.path.id}`,
    method: "DELETE",
});
ApiEpBillingBill.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/bill/`,
    method: "GET",
    next: req === null || req === void 0 ? void 0 : req.next,
    query: req === null || req === void 0 ? void 0 : req.query,
});
ApiEpBillingBill.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/bill/${req.path.id}`,
    method: "GET",
});
ApiEpBillingBill.update = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/bill/${req.path.id}`,
    method: "PUT",
});
ApiEpBillingBill.updatePartial = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/bill/${req.path.id}`,
    method: "PATCH",
});
//# sourceMappingURL=bill.js.map